import React, { FC, useEffect, useState } from "react";
import ApiInterface from "@/commons/api/ApiInterface";
import { useInfoBox } from "@/commons/infoBox/InfoBox";
import CloudImage from "@/commons/components/image/CloudImage";
import CustomButton from "@/commons/components/buttons/customButton/CustomButton";
import CustomSelect from "@/commons/components/fields/customSelect/CustomSelect";

interface UserProfileProps {
    profile: any;
    viewer: any;
    roles: any;
}

const UserProfileObject: FC<UserProfileProps> = ({ profile, viewer, roles }) => {
    const { addInfo } = useInfoBox();

    const [localRole, setLocalRole] = useState<string>(profile.staffGroup?.groupName || "");

    const updateSelf = async () => {
        const updatedUser = await ApiInterface.getLightUser(profile.uid);
        updateProfile(updatedUser);
    };

    const updateProfile = (updatedJson: any) => {
        profile.updateAll(updatedJson);
        setLocalRole(updatedJson.staffGroup?.groupName || "");
    };

    const handleRoleChange = (newRole: string) => {
        setLocalRole(newRole);
        ApiInterface.updateRole(profile.uid, newRole).then((res) => {
            if (res.status !== 200) {
                addInfo("alert", "Errore", "C'è stato un errore durante l'aggiornamento del ruolo dell'utente!", 5);
            } else {
                addInfo("success", "Ruolo aggiornato", "Il ruolo dell'utente è stato aggiornato correttamente!", 5);
                updateSelf();
            }
        });
    };

    const handleBanAction = () => {
        const action = profile.status?.toUpperCase() !== "BANNED" ? "banuser" : "unbanuser";
        const successMessage = action === "banuser" ? "Bannato" : "Sbannato";
        ApiInterface[action](profile.uid).then((res) => {
            if (res.status !== 200) {
                addInfo("alert", "Errore", "C'è stato un errore durante la richiesta!", 5);
            } else {
                addInfo("success", successMessage, `L'utente è stato ${successMessage.toLowerCase()} correttamente!`, 5);
            }
            updateSelf();
        });
    };

    const viewerPower = viewer?.staffGroup?.groupPower || 0;
    const userPower = profile.staffGroup?.groupPower || 0;

    const roleOptions =
        roles?.getLength?.() > 0
            ? Array.from({ length: roles.getLength() }).map((_, i) => {
                const role = roles.getRole(i);
                const disabled =
                    userPower > viewerPower ||
                    viewerPower <= role.groupPower ||
                    role.groupName === profile.staffGroup?.groupName;

                return {
                    label: role.groupName,
                    value: role.groupName,
                    disabled,
                };
            })
            : [];

    return (
        <div className="profileManager__userItem" data-uid={profile.uid}>
            <div className="profileManager__userItemUsername">
                {profile.username}
                <br />
                <a style={{ color: "#b90000" }} href={`/user/${profile.id}/`}>
                    Visualizza profilo
                </a>
            </div>
            <div className="profileManager__userItemEmail">{profile.email}</div>
            <div className="profileManager__userItemRole">
                <CloudImage
                    uuid={profile.staffGroup.iconUUID}
                    className="profileManager__userItemRoleImage"
                    alt={profile.staffGroup.groupName}
                />
            </div>
            <div className="profileManager__userItemActions">
                <div className="profileManager__userItemActionTitle">Gestione utente</div>
                <CustomButton
                    className="profileManager__userItemActionBan"
                    onClick={handleBanAction}
                >
                    {profile.status?.toUpperCase() !== "BANNED" ? "Banna" : "Sbanna"}
                </CustomButton>
                <div className="profileManager__userItemActionRole">
                    <CustomSelect
                        label="Ruolo"
                        options={roleOptions}
                        value={localRole}
                        onChange={handleRoleChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default UserProfileObject;